// Campus photo for /colleges/university-of-the-pacific: Public domain, by Carol M. Highsmith, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMorris_Chapel_at_the_University_of_the_Pacific_in_Stockton%2C_California_LCCN2013633098.tif), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-the-pacific/; credited under the photo.
const photo = {
    "slug": "university-of-the-pacific",
    "alt": "Morris Chapel, a brick chapel with a white steeple, behind a tree-lined walk at the University of the Pacific in Stockton, California",
    "src": "/colleges/university-of-the-pacific/campus-1600.webp",
    "srcSmall": "/colleges/university-of-the-pacific/campus-800.webp",
    "srcMid": "/colleges/university-of-the-pacific/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-the-pacific/og.jpg",
    "title": "Morris Chapel at the University of the Pacific in Stockton, California LCCN2013633098",
    "author": "Carol M. Highsmith",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMorris_Chapel_at_the_University_of_the_Pacific_in_Stockton%2C_California_LCCN2013633098.tif",
    "read": "2026-10-02"
};

export default photo;
